<template>
    <div
        class="app-container"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-row style="padding-bottom: 15px">
            <el-col :span="24">
                <h3 class="headtitle">同步记录</h3>
                <span>同步数据记录</span>
            </el-col>
        </el-row>
        <el-card>
            <el-row style="margin-bottom: 5px">
                <el-button
                    icon="el-icon-download"
                    plian
                    class="pull-right right-5"
                    style="padding-bottom: 5px"
                    @click="excel"
                    size="mini"
                    >{{ L('ExportToExcel') }}</el-button
                >
            </el-row>
            <el-form size="small" label-width="120px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="L('DateRange')">
                            <DateRangePicker
                                :start.sync="fetchParams.startDate"
                                :end.sync="fetchParams.endDate"
                            ></DateRangePicker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="L('Service')">
                            <el-input
                                :placeholder="L('Service')"
                                v-model="fetchParams.serviceName"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="L('ErrorState')">
                            <el-select
                                style="width: 100%"
                                size="small"
                                :placeholder="errorState.label"
                                v-model="fetchParams.hasException"
                            >
                                <el-option
                                    v-for="item in errorState.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="L('UserName')">
                            <el-input
                                :placeholder="L('UserName')"
                                v-model="fetchParams.userName"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="L('Action')">
                            <el-input
                                :placeholder="L('Action')"
                                v-model="fetchParams.methodName"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span='12'>
            <el-form-item :label='L('Browser')'>
              <el-input :placeholder='L('Browser')' v-model='fetchParams.browserInfo'></el-input>
            </el-form-item>
          </el-col>-->
                </el-row>
            </el-form>
            <el-table
                :data="tableData"
                size="mini"
                style="width: 100%"
                border
                @sort-change="sortChanged"
            >
                <el-table-column
                    min-width="160"
                    :label="L('Time')"
                    prop="executionTime"
                    sortable
                >
                    <template slot-scope="scope">
                        <!-- <i>{{scope.row.executionTime|DateTimeFormat('YYYY-MM-DD HH:mm:ss')}}</i> -->
                        <i>{{ scope.row.executionTimeStr }}</i>
                    </template>
                </el-table-column>
                <el-table-column
                    width="120"
                    prop="operUserName"
                    :label="L('UserName')"
                    sortable
                ></el-table-column>
                <el-table-column
                    width="120"
                    prop="accountConfInfoName"
                    :label="L('AccountConfInfoName')"
                    sortable
                ></el-table-column>
                <el-table-column
                    min-width="250"
                    prop="hangfireAccount.serviceName"
                    :label="L('Service')"
                ></el-table-column>
                <el-table-column
                    min-width="250"
                    prop="hangfireAccount.methodName"
                    :label="L('Action')"
                ></el-table-column>
                <el-table-column
                    width="150"
                    :label="L('Duration')"
                    prop="hangfireAccount.executionDuration"
                    sortable
                >
                    <template slot-scope="scope">
                        <i
                            >{{
                                scope.row.hangfireAccount.executionDuration
                            }}
                            ms</i
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    prop="hangfireAccount.clientIpAddress"
                    width="120"
                    :label="L('IpAddress')"
                ></el-table-column>
                <el-table-column
                    prop="hangfireAccount.clientName"
                    width="100"
                    :label="L('Client')"
                ></el-table-column>
                <el-table-column width="100">
                    <template slot-scope="scope">
                        <el-button
                            size="small"
                            icon="el-icon-search"
                            @click="opendialogDetail(scope.row.hangfireAccount)"
                        ></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagerBar
                ref="refPagerBar"
                :apiURL="taskLogApiUrl"
                :GetData="taskLogData"
                :queryParam="fetchParams"
            ></pagerBar>
        </el-card>
        <el-dialog
            v-el-drag-dialog
            class="dialog-detail"
            :title="L('AuditLogDetail')"
            :visible.sync="dialogDetail.isShow"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <article>
                <h2>{{ L('UserInformations') }}</h2>
                <article>
                    <section>
                        <em>{{ L('UserName') }}:</em>
                        {{ dialogDetail.model.userName }}
                    </section>
                    <section>
                        <em>{{ L('IpAddress') }}:</em>
                        {{ dialogDetail.model.clientIpAddress }}
                    </section>
                    <section>
                        <em>{{ L('Client') }}:</em>
                        {{ dialogDetail.model.clientName }}
                    </section>
                    <section>
                        <em>{{ L('Browser') }}:</em>
                        {{ dialogDetail.model.browserInfo }}
                    </section>
                </article>

                <h2>{{ L('ActionInformations') }}</h2>
                <article>
                    <section>
                        <em>{{ L('Service') }}:</em>
                        {{ dialogDetail.model.serviceName }}
                    </section>
                    <section>
                        <em>{{ L('Action') }}:</em>
                        {{ dialogDetail.model.methodName }}
                    </section>
                    <section>
                        <em>{{ L('Time') }}:</em>
                        {{ dialogDetail.model.executionTime }}
                    </section>
                    <section>
                        <em>{{ L('Duration') }}:</em>
                        {{ dialogDetail.model.executionDuration }} ms
                    </section>
                    <section>
                        <em>{{ L('Parameters') }}:</em>
                        <!-- <pre lang='js'>{{dialogDetail.model.parameters ? JSON.stringify(JSON.parse(dialogDetail.model.parameters), null, '\t') : ''}}</pre> -->
                    </section>
                </article>

                <h2>{{ L('CustomData') }}</h2>
                <article>
                    <section>
                        {{ dialogDetail.model.customData || L('None') }}
                    </section>
                </article>

                <h2>{{ L('ErrorState') }}</h2>
                <article class="error-status">
                    <section>
                        <i
                            class="fa fa-check-circle text-success"
                            style="font-size: 18px"
                            v-if="!dialogDetail.model.exception"
                        ></i>
                        <span>{{
                            dialogDetail.model.exception || L('Success')
                        }}</span>
                    </section>
                </article>
            </article>
            <span slot="footer" class="dialog-footer">
                <el-button
                    class="waves-effect"
                    @click="dialogDetail.isShow = false"
                    >{{ L('Close') }}</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>


<script>
import DateRangePicker from '../../components/daterange/DateRangePicker'
import pagerBar from '@/views/pager/pagerBar'
import moment from 'moment'
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    data() {
        return {
            taskLogApiUrl: config.BASE_Middle_API + 'HangfireAccounts/GetAll',
            excelUrl: config.BASE_Middle_API + 'HangfireAccounts/GetAllToExcel',
            openloading: true,
            fetchParams: {
                startDate: moment().startOf('day')._d,
                endDate: moment().endOf('day')._d,
                serviceName: '',
                hasException: null,
                userName: '',
                methodName: '',
                sorting: ''
            },
            tableData: [],
            errorState: {
                options: [
                    {
                        value: null,
                        label: this.L('All')
                    },
                    {
                        value: false,
                        label: 'Success'
                    },
                    {
                        value: true,
                        label: 'HasError'
                    }
                ],
                value: null,
                label: this.L('All')
            },
            dialogDetail: {
                isShow: false,
                model: {}
            }
        }
    },
    mounted() {},
    methods: {
        excel() {
            const _this = this
            let search = Object.assign({}, _this.fetchParams)
            search.startDate = _this.fetchParams.startDate
            search.endDate = _this.fetchParams.endDate
            AjaxHelper.get(_this.excelUrl, search)
                .then(function (response) {
                    if (response.success) {
                        const url =
                            config.remoteUrl +
                            '/File/DownloadTempFile?fileType=' +
                            response.result.fileType +
                            '&fileToken=' +
                            response.result.fileToken +
                            '&fileName=' +
                            response.result.fileName
                        window.open(url)
                    }
                })
                .catch(function (error) {
                    _this.$message({
                        type: 'danger',
                        message: error
                    })
                })
        },

        taskLogData(d) {
            this.tableData = d
            this.openloading = false
        },
        opendialogDetail(model) {
            this.dialogDetail.isShow = true
            this.dialogDetail.model = model
        },
        refresh() {
            this.$refs.pagerBar.Refresh()
        },
        sortChanged({ column, prop, order }) {
            if (prop && order) {
                this.fetchParams.sorting = prop + ' ' + order
            }
        }
    },

    components: {
        DateRangePicker,
        pagerBar
    }
}
</script>
    